(function() {
  var homeslider;

  $('select.mobile-navigation').on('change', function() {
    return window.location = $(this).find("option:selected").val();
  });

  $('.selectpicker').on('changed.bs.select', function() {
    return window.location = $(this).find('option:selected').data('url');
  });

  $("#home-price-trend-switch-country").on("change", function() {
    return window.location = $(this).val();
  });

  $('#_mobile-navigation-toggle-button').on('click', function() {
    return $('#mobile-navigation-menu .mobile-navigation-toggle').slideToggle();
  });

  $(".input-group.password-group").on("mousedown", function() {
    return $(this).find("i.glyphicon").removeClass("glyphicon-eye-open").addClass("glyphicon-eye-close");
  });

  $(".input-group.password-group").on("mouseup", function() {
    return $(this).find("i.glyphicon").removeClass("glyphicon-eye-close").addClass("glyphicon-eye-open");
  });

  $("#simpletable").stupidtable();

  $('#newsletter_popup').slideUp();

  setTimeout((function() {
    $('#newsletter_popup').slideDown();
  }), 10000);

  setTimeout((function() {
    $('#newsletter_popup .body').slideUp();
  }), 15000);

  if ($('#ad-bottom-affix').length && $(window).width() > 768) {
    $('#ad-bottom-affix').affix({
      offset: {
        top: $('#ad-bottom-affix').offset().top + 300,
        bottom: $('footer').outerHeight(true) + 250
      }
    });
    $("#ad-bottom-affix").on("affixed.bs.affix", function() {
      return $(this).removeAttr("style");
    });
  }

  if ($('#ad-left-affix').length && $(window).width() > 768) {
    $('#ad-left-affix').affix({
      offset: {
        top: $('#ad-left-affix').offset().top,
        bottom: $('footer').outerHeight(true) + 250
      }
    });
    $("#ad-left-affix").on("affixed.bs.affix", function() {
      return $(this).removeAttr("style");
    });
  }

  $('[data-toggle="tooltip"]').tooltip();

  $('.event-newsletter').on('click', function(e) {
    var type;
    type = $(this).data('event');
    return gtag('event', 'click', {
      'event_category': 'Newsletter',
      'event_label': type
    });
  });

  $('.event-newsletter-widget').on('click', function(e) {
    var type;
    type = $(this).data('event');
    return gtag('event', 'click', {
      'event_category': 'Newsletter Widget',
      'event_label': type
    });
  });

  $('#compare-country-region-switch').on('change', function() {
    var region_filter, region_id, rest, selected, table_mode;
    region_filter = '';
    region_id = $(this).val();
    table_mode = $("#simpletable.tabular-data").data('default-display-mode');
    if (table_mode === 'nominal' || table_mode === 'inflation-adjusted') {
      region_filter = "." + table_mode;
    }
    if (region_id === 'all') {
      if (region_filter === '') {
        $("#simpletable.tabular-data tbody tr").show();
      } else {
        $("#simpletable.tabular-data tbody tr" + region_filter).show();
      }
      return true;
    }
    selected = "#simpletable.tabular-data tbody tr.region-" + region_id + region_filter;
    rest = "#simpletable.tabular-data tbody tr:not(.region-" + region_id + ")";
    $(selected).show();
    return $(rest).hide();
  });

  $("#mobile-country-tab-selector").on('change', function() {
    var selected;
    selected = $(this).val();
    return $("ul.nav.nav-tabs li a[aria-controls=" + selected + "]").trigger('click');
  });

  $("ul.nav.nav-tabs li a").on('click', function() {
    var selected;
    selected = $(this).attr('aria-controls');
    return $("#mobile-country-tab-selector option[value=" + selected + "]").prop('selected', true);
  });

  $('[data-toggle="popover"]').popover({
    html: true
  });

  $('.psuedo-link').on('click', function(e) {
    return e.preventDefault();
  });

  $(document).ready(function() {
    var inputBox, isOpen, searchBox, submitIcon;
    submitIcon = $('.searchbox-icon');
    inputBox = $('.searchbox-input');
    searchBox = $('.searchbox');
    isOpen = false;
    submitIcon.click(function() {
      if (isOpen === false) {
        searchBox.addClass('searchbox-open');
        inputBox.focus();
        isOpen = true;
      } else {
        searchBox.removeClass('searchbox-open');
        inputBox.focusout();
        isOpen = false;
      }
    });
    submitIcon.mouseup(function() {
      return false;
    });
    searchBox.mouseup(function() {
      return false;
    });
    $(document).mouseup(function() {
      if (isOpen === true) {
        $('.searchbox-icon').css('display', 'block');
        submitIcon.click();
      }
    });
  });

  $('form#search_for_properties').on("submit", function(e) {
    var _defaultURL, _targetURL, location, price, type;
    _defaultURL = 'http://search.globalpropertyguide.com/property/all/';
    _targetURL = 'http://search.globalpropertyguide.com/property';
    price = $('#searchBox_PriceIndex').val();
    type = $('#searchIntellType').val();
    location = $('#searchIntellLocation').val();
    if (price === '0' && type === "-1" && location === '') {
      window.location = _defaultURL;
      return;
    }
    if (type !== '-1') {
      _targetURL += '/' + type;
    }
    if (price > 0) {
      $("#tmc_searchBox_PriceIndex").val(price);
    }
    if (location === '') {
      _targetURL += '/' + $(this).data('country').replace(/ /g, "_").toLowerCase() + '/';
    } else {
      _targetURL += '/' + location.replace(/ /g, "_").toLowerCase() + '/';
    }
    return $(this).prop('action', _targetURL);
  });

  $('img#header-image-map').rwdImageMaps();

  homeslider = $("#lightSlider").lightSlider({
    item: 1,
    loop: true,
    gallery: true,
    slideMargin: 0,
    thumbItem: 8,
    speed: 400,
    auto: true
  });

  $("#login-password-peek").on("mousedown", function() {
    return $("#login-password").attr("type", "text");
  });

  $("#login-password-peek").on("mouseup", function() {
    return $("#login-password").attr("type", "password");
  });

  $('form#global-login-modal-form').on("submit", function(e) {
    var _status, _submit, _token, email, password, payload;
    e.preventDefault();
    email = $('#login-email').val();
    password = $('#login-password').val();
    _token = $('#login-token').val();
    _status = $('#login-status');
    _submit = $('#login-submit').html('Logging in...');
    payload = {
      email: email,
      password: password,
      _token: _token
    };
    return $.post('/login-modal', payload).done(function() {
      _status.removeClass('hidden').removeClass('bg-danger').addClass('bg-success').html('Login was successful');
      return window.location = "profile/dashboard";
    }).fail(function(response) {
      if (response.status === 403) {
        return _status.removeClass('hidden').removeClass('bg-success').addClass('bg-danger').html('Your session has expired due to inactivity.<br>Please refresh the page and try again.');
      } else {
        return _status.removeClass('hidden').removeClass('bg-success').addClass('bg-danger').html('Email or password is incorrect. Please make sure you are using a verified account, and try again.');
      }
    }).always(function() {
      return _submit.html('Login');
    });
  });

  $("#signup-password-peek").on("mousedown", function() {
    return $("#signup-password").attr("type", "text");
  });

  $("#signup-password-peek").on("mouseup", function() {
    return $("#signup-password").attr("type", "password");
  });

  $('form#global-signup-modal-form').on("submit", function(e) {
    var _status, _submit, _token, accept_policies, email, name, newsletter, password, payload, plan;
    e.preventDefault();
    name = $('#signup-name').val();
    email = $('#signup-email').val();
    password = $('#signup-password').val();
    plan = $('#service-provider-register-plan').val();
    newsletter = ($('#signup-newsletter').is(':checked')) ? 1 : 0;
    accept_policies = ($('#accept-policies').is(':checked')) ? 1 : 0;
    _token = $('#signup-token').val();
    _status = $('#signup-status').addClass('hidden');
    _submit = $('#signup-submit').html('Signing up...');
    payload = {
      name: name,
      email: email,
      password: password,
      plan: plan,
      newsletter: newsletter,
      accept_policies: accept_policies,
      _token: _token
    };
    if (newsletter) {
      gtag('event', 'click', {
        'event_category': 'Newsletter',
        'event_label': 'Registration with newsletter opt-in'
      });
    }
    return $.post('/register-modal', payload).done(function(response) {
      return window.location = "service-providers/checkout/" + response.plan + "/" + response.member_id;
    }).fail(function(response) {
      if (response.status === 403) {
        _status.removeClass('bg-success').addClass('bg-danger').html('Your session has expired due to inactivity.<br>Please refresh the page and try again.');
      }
      if (response.responseJSON === void 0) {
        return;
      }
      if (response.responseJSON["email"]) {
        return _status.removeClass('bg-success').addClass('bg-danger').html(response.responseJSON.email);
      } else if (response.responseJSON.hasOwnProperty["password"]) {
        return _status.removeClass('bg-success').addClass('bg-danger').html(response.responseJSON.password);
      } else if (response.responseJSON["accept_policies"]) {
        return _status.removeClass('bg-success').addClass('bg-danger').html("You need to accept the policies to sign up");
      } else {
        return _status.removeClass('bg-success').addClass('bg-danger').html(response.responseJSON.error);
      }
    }).always(function() {
      _status.removeClass('hidden');
      return _submit.html('Signup');
    });
  });

  $('form#global-forgot-password-modal-form').on("submit", function(e) {
    var _status, _submit, _token, email, payload;
    e.preventDefault();
    email = $('#forgot-password-email').val();
    _token = $('#forgot-password-token').val();
    _status = $('#forgot-password-status').addClass('hidden');
    _submit = $('#forgot-password-submit').html('Sending Instructions...');
    payload = {
      email: email,
      _token: _token
    };
    return $.post('/password/email-modal', payload).done(function(response) {
      _status.removeClass('bg-danger').addClass('hidden');
      $("#forgot-password-email-address strong").html(email);
      $('form#global-forgot-password-modal-form').addClass('hidden');
      return $("#forgot-password-success").removeClass('hidden');
    }).fail(function(response) {
      if (response.responseJSON === void 0) {
        return;
      }
      if (response.responseJSON["email"]) {
        return _status.removeClass('bg-success').addClass('bg-danger').html(response.responseJSON.email);
      } else {
        return _status.removeClass('bg-success').addClass('bg-danger').html(response.responseJSON.error);
      }
    }).always(function() {
      _status.removeClass('hidden');
      return _submit.html('Signup');
    });
  });

  $('#v-spModal form').on("submit", function(e) {
    var _status, _token, contact_me, country_id, email, form, message, name, payload, phone, ref, spid, submit;
    e.preventDefault();
    form = $(this);
    name = $('#v-spModal input[name="name"]');
    country_id = $('#v-spModal select[name="country_id"]');
    phone = $('#v-spModal input[name="phone"]');
    message = $('#v-spModal textarea[name="message"]');
    spid = $('#v-spModal input[name="spid"]');
    contact_me = $('#v-spModal input[name="contact_me"]');
    email = $('#v-spModal input[name="email"]');
    _token = $('#v-spModal input[name="_token"]');
    _status = $('#spModal-status');
    submit = $('#v-spModal button[type="submit"]');
    submit.html('Sending...');
    payload = {
      name: name.val(),
      country_id: country_id.val(),
      phone: phone.val(),
      message: message.val(),
      email: email.val(),
      spid: spid.val(),
      _token: _token.val(),
      contact_me: (ref = contact_me.val()) != null ? ref : {
        1: 0
      }
    };
    return $.post('/service-providers/send_message', payload).done(function() {
      name.val('');
      country_id.val('');
      email.val('');
      phone.val('');
      message.val('');
      _status.removeClass('alert-danger').addClass('alert-success').html('Your message has been sent!');
      $('#sp-modal-form-status').show();
      return $('#sp-modal-form').hide();
    }).fail(function() {
      return _status.removeClass('alert-success').addClass('alert-danger').html('Something went wrong. Please check your input and try again, or visit the agents page for more information.');
    }).always(function() {
      submit.html('Send');
      return _status.removeClass('hidden').show();
    });
  });

  $('#v-spModal .closeModal').on("click", function(e) {
    var _status, contact_me, email, first_name, last_name, message, phone, spid;
    e.preventDefault();
    first_name = $('#v-spModal input[name="first_name"]').val('');
    last_name = $('#v-spModal input[name="last_name"]').val('');
    phone = $('#v-spModal input[name="phone"]').val('');
    message = $('#v-spModal textarea[name="message"]').val('');
    spid = $('#v-spModal input[name="spid"]').val('');
    contact_me = $('#v-spModal input[name="contact_me"]').val('');
    email = $('#v-spModal input[name="email"]').val('');
    return _status = $('#spModal-status').addClass('hidden').html('');
  });

  $('form#comment-box').on("submit", function(e) {
    var form, payload;
    e.preventDefault();
    form = $(this);
    payload = {
      name: $('#comment-box input[id="name"]').val(),
      email: $('#comment-box input[id="email"]').val(),
      article_id: $('#comment-box input[name="article_id"]').val(),
      type: $('#comment-box input[name="type"]').val(),
      message: $('#comment-box textarea[id="message"]').val(),
      _token: $('#comment-box input[name="_token"]').val()
    };
    $('#comment-success').addClass('hidden');
    $('.comment-form-error').addClass('hidden');
    return $.post('/comments', payload).done(function() {
      form.hide();
      return $('#comment-success').removeClass('hidden');
    }).fail(function(data) {
      $('.comment-form-error ul').html('');
      $.each(data.responseJSON, function(i, val) {
        return $('.comment-form-error ul').append('<li>' + val + '</li>');
      });
      return $('.comment-form-error').removeClass('hidden');
    }).always(function() {});
  });

  $('#profile-edit-submit').on('click', function(e) {
    var validation;
    validation = document.querySelector("#profile-edit").reportValidity();
    if (validation === false) {
      $('ul.nav.nav-tabs a[aria-controls="contact-info"]').trigger('click');
      document.querySelector("#profile-edit").reportValidity();
      return;
    }
    return $('#profile-edit').trigger('submit');
  });

  $('#profile .gallery-delete').on("click", function(e) {
    var answer, gallery_id;
    e.preventDefault();
    answer = confirm("Are you sure you want to delete?");
    if (answer !== true) {
      return;
    }
    gallery_id = $(this).data("id");
    $(this).html('DELETING...');
    return $.get("/profile/gallery/" + gallery_id + "/delete").done(function(response) {
      $("#gallery-" + gallery_id).remove();
      return $("#image-form").show();
    }).fail(function(response) {
      if (response.status === 404) {
        return alert("The asset can no longer be found. Please refresh to confirm that the asset has been deleted.");
      }
    }).always(function() {});
  });

}).call(this);

(function() {


}).call(this);

(function() {
  $('body').on('click', function(e) {
    var dropdown, trigger1;
    trigger1 = $("#mobile-navigation-toggle-button")[0];
    dropdown = $(".mobile-navigation-toggle");
    if (dropdown !== e.target && !dropdown.has(e.target).length && trigger1 !== e.target) {
      return $(".mobile-navigation-toggle").hide();
    }
  });

  $(window).on('scroll', function() {
    var scroll;
    scroll = $(window).scrollTop();
    if (scroll >= 100) {
      $('#header-top').addClass('hidden-xs');
      $('.breadcrumb-fixed').addClass('darkHeader');
    } else {
      $('#header-top').removeClass('hidden-xs');
      $('.breadcrumb-fixed').removeClass('darkHeader');
    }
  });

  $('#mobile-navigation-toggle-button span').on('click', function(e) {
    e.stopPropagation();
    $(".mobile-navigation-toggle").slideToggle();
    $(".menu-mobile .dropdown").removeClass("open");
    return $(".dropdown-menu").hide();
  });

  $('#mobile-navigation-toggle-button').on('click', function(e) {
    e.preventDefault();
    if ($(e.currentTarget).hasClass('btn-primary')) {
      $(".mobile-navigation-toggle").slideToggle();
      $(".menu-mobile .dropdown").removeClass("open");
      $(".dropdown-menu").hide();
    } else {
      $("._mobile-navigation-toggle").slideToggle();
      $("._menu-mobile .dropdown").removeClass("open");
      $(".dropdown-menu").hide();
    }
  });

  $(document).on("show.bs.dropdown", ".dropdown", function() {
    return $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
  });

  $(document).on("hide.bs.dropdown", ".dropdown", function() {
    return $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
  });

  $(document).on("click", ".dropdown-toggle", function() {
    return $(".mobile-navigation-toggle").hide();
  });

}).call(this);

//# sourceMappingURL=theme.js.map
